import clsx from '@vangst/lib/clsx'
import { MdClose, MdSearch } from 'react-icons/md'
import Input from '../../components/forms/Input'
import ClickyBtn from '../../components/navigation/ClickyBtn'
import useQueryParams from '../search/useQueryParams'
import useRouterControl from '../search/useRouterControl'

type PropsType = React.HTMLAttributes<HTMLElement>

export default function LearnTabs(props: PropsType) {
  const { className, ...rest } = props
  const { getQueryParams, setQueryParams } = useQueryParams()
  const { register, submit, debounced } = useRouterControl()
  const reset = () => setQueryParams({})
  const params = getQueryParams()

  return (
    <nav
      aria-label="Learn Navigation"
      className={clsx(
        'flow-y-sm border-b border-b-grey sm:flex-row sm:items-end sm:justify-between',
        className,
      )}
      {...rest}
    >
      <form
        className="flex w-full max-w-sm items-end sm:order-last sm:ml-auto sm:translate-y-[0.5625rem]"
        id="search-blog-form"
        onChange={debounced}
        onReset={reset}
        onSubmit={submit}
      >
        <Input
          className="border-r-0"
          hideLabel
          placeholder="Search articles"
          label="Search"
          {...register('searchTerm')}
        />
        {params.searchTerm ? (
          <ClickyBtn
            as="icon"
            className="mood-white -translate-y-2"
            title="Reset"
            type="reset"
          >
            <MdClose />
          </ClickyBtn>
        ) : (
          <ClickyBtn
            aria-label="Submit"
            title="Submit"
            className="mood-orange -translate-y-2"
            type="submit"
          >
            <MdSearch />
          </ClickyBtn>
        )}
      </form>
    </nav>
  )
}
